import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { DashboardComponent } from './dashboard/dashboard.component'; 
import { AuthGuard } from 'src/app/guard/auth.guard';
import { CompaniesComponent } from './dashboard/crud/companies/companies.component'; 
import { AppsComponent } from './dashboard/crud/apps/apps.component';
import { LogsComponent } from './dashboard/crud/logs/logs.component'
import { DocumentsComponent } from './dashboard/crud/documents/documents.component';
import { CodeRequestComponent } from './dashboard/crud/code-request/code-request.component';
import { ListCodeRequestComponent } from './dashboard/crud/list-code-request/list-code-request.component';
import { BinnacleComponent } from './dashboard/crud/binnacle/binnacle.component';
import { ListBinnacleComponent } from './dashboard/crud/list-binnacle/list-binnacle.component';
import { WorkOrdersComponent } from './dashboard/crud/work-orders/work-orders.component';

const routes: Routes = [
  {
    path: 'admin/dashboard',
    children: [
      { path: '', component: DashboardComponent, canActivate: [AuthGuard] },
      { path: 'crud/companies', component: CompaniesComponent },
      { path: 'crud/apps', component: AppsComponent },
      { path: 'crud/logs', component: LogsComponent },
      { path: 'crud/documents', component: DocumentsComponent },
      { path: 'crud/codes', component: CodeRequestComponent },
      { path: 'crud/listCodes', component: ListCodeRequestComponent },
      { path: 'crud/binnacles', component: BinnacleComponent },
      { path: 'crud/listBinnacles', component: ListBinnacleComponent },
      { path: 'crud/listWorkOrders', component: WorkOrdersComponent },
    ]
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class AdminRoutingModule { }
